import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { LeadNote } from '../../cmg-1003/models/notes.model';

function createInitialState(): LeadNote {
  return <LeadNote>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-lead-notes' })
export class LeadNotesDataStore extends Store<LeadNote> {
  constructor() {
    super(createInitialState());
  }

  akitaPreUpdate = (model: Readonly<LeadNote>, updatedModel: LeadNote) => {
    return updatedModel;
  };
}
